import { makeRoute } from '~/utils/route';

export default makeRoute({
	path:        '/admin/upload',
	title:       'menu.admin-upload',
	// @ts-ignore
	redirectTo:  () => {
		window.location.href = '/front5/admin/upload';
	},
});
